/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import * as actions from '../../action';
import * as c from '../../constant';

const CMS_TYPE = 'COMPONENTS';

function MenuSidebarListModal({
  getList,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  createCheckbox,
  fields,
  menuSidebarfields,
}) {
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);


  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {

      setModal({ isOpen: false });
      return update(_.get(formData, 'id'), {
        type: CMS_TYPE,
        body: JSON.stringify(_.pick(formData, [...fields, ...menuSidebarfields])),
      });
    }

    setModal({ isOpen: false });
    return create({
      type: CMS_TYPE,
      body: JSON.stringify(_.pick(formData, [...fields, ...menuSidebarfields])),
    });
  };

  const mainMenu = menuSidebarfields.filter(l => !l.includes('SUB_MENU'))

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {createHidden({ key: 'id' }, { placeholder: '' })}
        <div className="alert alert-primary" style={{ fontSize: '12px' }}>
          <b className="pb-2">Legend:</b>
          <div className="text-dark">
            <i className="fas fa-check-square" style={{ color: '#1075FF' }} />
            <i> - HIDE Menu</i>
          </div>
          <div className="text-dark pb-2">
            <i className="far fa-square" style={{ color: '#000' }} /> 
            <i> - SHOW Menu</i>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between px-4 border-bottom">
          <b>Label</b> 
          <b>Toggle</b> 
        </div>
        <div className="row" style={{ maxHeight: '500px', overflow: 'hidden', overflowY: 'scroll' }}>
          {menuSidebarfields.map((data, index) => {
            const listSequence = mainMenu.map((d, i) => {
              if (d === data) return `${++i}.`;
              return '';
            });

            return (
              <div
                key={index}
                className={`col-12 group-cms-color form-input-group d-flex ml-2 checkbox-menu-container ${
                  data.includes('SUB_MENU') ? 'pl-5' : ''
                }`}
              >
                <b className="mr-1">
                  {data.includes('SUB_MENU') ? '-' : listSequence}
                </b>
                <div className="d-flex justify-content-between w-100 pr-4">
                  {createCheckbox(
                    { key: data, label: data },
                    {className: 'd-flex align-items-center align-self-center flex-column-reverse',}
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* submit */}
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

MenuSidebarListModal.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  fields: PropTypes.instanceOf(Array).isRequired,
  menuSidebarfields: PropTypes.instanceOf(Array).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(MenuSidebarListModal);